import { Card, Descriptions } from 'antd'
import { useTranslation } from 'react-i18next'

import type { ReceivedCancellationRequestRoot } from '@repo/sdk'

import { BuyerLink } from '../../components/BuyerLink'

interface CancellationBuyerInfoCardProps {
  cancellation: ReceivedCancellationRequestRoot
}

export function CancellationBuyerInfoCard({ cancellation }: CancellationBuyerInfoCardProps) {
  const { t } = useTranslation()

  return (
    <Card title={t('pages.cancellations.sections.buyerInfo')} bordered>
      <Descriptions column={1} size="small">
        <Descriptions.Item label={t('pages.cancellations.fields.buyerNickname')}>
          <BuyerLink buyer={cancellation.buyer} showAvatar />
        </Descriptions.Item>
      </Descriptions>
    </Card>
  )
}
